export const markName = 'emojiSuggest';
export const pluginKeyName = 'emojiSuggest';
